import { Pipe, PipeTransform } from '@angular/core';

import { TranslationParams, TranslationService } from './translation.service';

@Pipe({
  name: 't',
  standalone: true,
  pure: false,
})
export class TranslationPipe implements PipeTransform {
  constructor(private readonly translationService: TranslationService) {}

  transform(key: string, params?: TranslationParams, count?: number): string {
    return this.translationService.translate(key, params, count);
  }
}
